import HomePage from './HomePage'
import enhance from './HomePage.enhancer'

export default enhance(HomePage)



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomePage/index.js